<template>
  <div>
    <div
      id="svg-poster-classic"
      :style="{ backgroundColor: styles.background }"
      class="landscape poster"
    >
      <svg width="100%" height="100%" :viewBox="viewBox">
        <defs>
          <linearGradient id="gradient" x1="25%" y1="25%" x2="75%" y2="75%">
            <stop
              offset="0%"
              :stop-color="styles.gradient.color_0"
              stop-opacity="1"
            />
            <stop
              offset="50%"
              :stop-color="styles.gradient.color_1"
              stop-opacity="1"
            />
            <stop
              offset="100%"
              :stop-color="styles.gradient.color_2"
              stop-opacity="1"
            />
          </linearGradient>

          <mask id="maskGradient">
            <classic-viz
              v-if="posterState.layout == 'classic-svg'"
              :soundData="soundData"
              :x="startVisualX"
              :y="baseVisual.y + baseVisual.heightPadding"
              :width="widthVisual"
              :height="baseVisual.height - baseVisual.heightPadding * 2"
              :visualOptions="posterState.visualOptions"
            />
            <fourier-viz
              v-if="posterState.layout == 'straight-svg'"
              :soundData="soundData"
              :x="startVisualX"
              :y="baseVisual.y + baseVisual.heightPadding"
              :width="widthVisual"
              :height="baseVisual.height - baseVisual.heightPadding * 2"
              :fourier="soundData.fourier"
              :visualOptions="posterState.visualOptions"
            />
            <Grid
              v-if="posterState.options.hasGrid"
              :x="grid.x"
              :y="grid.y"
              :width="grid.width"
              :height="grid.height"
            />
            <PosterTextBox
              :headerText="posterState.heading"
              :dedicationText="posterState.dedication"
              :headerCssClass="
                posterState.options.useAlternativeFont
                  ? 'header-calligraphy'
                  : 'header-classic'
              "
              dedicationCssClass="dedication-classic"
              :yCenter="text.yBottomText"
              :xCenter="widthPoster / 2"
            />
            <PosterText
              :text="posterState.date"
              :yCenter="
                posterState.options.hasFrame
                  ? text.yDateFramed
                  : text.yDateNotFramed
              "
              :xCenter="widthPoster / 2"
              cssClass="date-classic"
            />
            <QrCode
              v-if="posterState.playbackOptions.qrCode"
              :posterHasFrame="posterState.options.hasFrame"
            />
          </mask>
        </defs>
        <!-- Soundwave -->
        <g>
          <rect
            :height="heightPoster"
            :width="widthPoster"
            stroke="none"
            fill="url(#gradient)"
            mask="url(#maskGradient)"
          />
          <!-- Frame -->
          <rect
            id="frame"
            v-if="posterState.options.hasFrame"
            :x="frame.xOuterDistance"
            :y="frame.yOuterDistance"
            fill="none"
            :height="heightPoster - 2 * frame.yOuterDistance"
            :width="widthPoster - 2 * frame.xOuterDistance"
            :stroke="styles.frameColor"
            :stroke-width="frame.width"
          />
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import classicStyles from '../../data/classicStyles.json'
import ClassicViz from './ClassicViz.vue'
import FourierViz from './FourierViz.vue'
import PosterText from './PosterText.vue'
import PosterTextBox from './PosterTextBox.vue'
import Grid from './Grid.vue'
import QrCode from './QrCode'
export default {
  name: 'PosterProper',
  props: {
    posterState: {
      type: Object,
      required: true,
    },
    soundData: {
      type: Object,
      required: true,
    },
  },
  data: function() {
    return {
      widthPoster: 700,
      heightPoster: 500,
      baseVisual: {
        x: 20,
        y: 70,
        height: 280,
        width: 660,
        heightPadding: 10,
      },
      frame: {
        width: 1.5,
        yOuterDistance: 20,
        yInnerDistance: -15,
        xOuterDistance: 20,
        xInnerDistance: -18,
      },
      text: {
        yBottomText: 415, // Default is being used when only Heading OR Dedication present
        yDateFramed: 49,
        yDateNotFramed: 40,
      },
    }
  },
  components: {
    ClassicViz,
    PosterText,
    PosterTextBox,
    FourierViz,
    Grid,
    QrCode,
  },
  computed: {
    startVisualX: function() {
      let x = this.baseVisual.x
      if (this.posterState.options.hasFrame) {
        x +=
          this.frame.xOuterDistance +
          this.frame.width +
          this.frame.xInnerDistance
      }
      return x
    },
    widthVisual: function() {
      let width = this.baseVisual.width
      if (this.posterState.options.hasFrame) {
        width -=
          (this.frame.xOuterDistance +
            this.frame.width +
            this.frame.xInnerDistance) *
          2
      }
      return width
    },
    grid: function() {
      const gridPadding = 0
      if (this.posterState.options.hasFrame) {
        return {
          width: this.widthPoster - 2 * this.frame.xOuterDistance,
          x: this.frame.xOuterDistance,
          y: this.baseVisual.y + gridPadding,
          height: this.baseVisual.height - gridPadding * 2,
        }
      } else {
        return {
          width: this.widthPoster,
          x: 0,
          y: this.baseVisual.y + gridPadding,
          height: this.baseVisual.height - gridPadding * 2,
        }
      }
    },
    styles: function() {
      return classicStyles.find((style) => {
        return style.id === this.posterState.colorClassic
      })
    },
    viewBox: function() {
      return [0, 0, this.widthPoster, this.heightPoster].join(' ')
    },
  },
}
</script>
<style scoped>
stop {
  transition: stop-color 700ms ease;
}

#svg-poster-classic {
  transition: background-color 700ms ease;
}

#frame {
  transition: stroke 700ms ease;
}
</style>
